<template>
  <section class="contact-section">
    <div class="white-section container no-bottom-mobile">
      <div class="contact-header">
        <h1>CONTACT US</h1>
        <p>
          If you have questions or comments, please don’t hesitate to reach out. We would be happy to help however we
          can. Looking to get started?
          <router-link class="link-color" :to="{ name: 'SignUp' }">Sign up
          </router-link>
          or
          <router-link class="link-color" :to="{ name: 'Request' }">request a kit
          </router-link>
          . Please allow 4–6 weeks for your kits to arrive.
        </p>
      </div>
      <img class="superhero-image" src="@/assets/images/global/super-hero-4.gif" alt=""/>
      <form class="jotform-form" method="post" name="form_212315091962149" id="212315091962149" accept-charset="utf-8"
            autocomplete="on" @submit.prevent="sendFormData()">
        <input type="hidden" name="formID" value="212315091962149"/> <input type="hidden" id="JWTContainer" value=""/>
        <input type="hidden" id="cardinalOrderNumber" value=""/>
        <div role="main" class="form-all">
          <ul class="form-section page-section">
            <li class="form-line jf-required" data-type="control_textbox" id="id_8">
              <label class="form-field name-field" id="label_8" for="input_8"> Name <span
                class="form-required"> * </span> </label>
              <div id="cid_8" class="form-input-wide jf-required">
                <input type="text" id="input_8" name="q8_name" data-type="input-textbox"
                       class="form-textbox validate[required] name-input" size="51" value="" placeholder=""
                       data-component="textbox" aria-labelledby="label_8" required=""/>
              </div>
            </li>
            <li class="form-line jf-required" data-type="control_email" id="id_7">
              <label class="form-label form-label-top form-label-auto" id="label_7" for="input_7"> Email address <span
                class="form-required"> * </span> </label>
              <div id="cid_7" class="form-input-wide jf-required">
                <input type="email" id="input_7" name="q7_emailAddress"
                       class="form-textbox validate[required, Email] name-input" size="51" value="" placeholder=""
                       data-component="email" aria-labelledby="label_7" required=""/>
              </div>
            </li>
            <li class="form-line jf-required" data-type="control_textarea" id="id_4">
              <label class="form-label form-label-top form-label-auto" id="label_4" for="input_4"> Message <span
                class="form-required"> * </span> </label>
              <div id="cid_4" class="form-input-wide jf-required">
                <div class="form-textarea-limit message-textarea">
                  <span>
                    <textarea id="input_4" class="form-textarea validate[required]" name="q4_yourMessage" cols="40"
                              rows="6" data-component="textarea" required=""></textarea>
                  </span>
                </div>
              </div>
            </li>
            <li style="display: none">
              Should be Empty: <input type="text" name="website" value=""/>
            </li>
          </ul>
        </div>
        <input type="hidden" class="simple_spc1" id="simple_spc1" name="simple_spc1" value="212315091962149"/> <input
        id="input_10" type="hidden" name="env" value="{ process.env.VUE_APP_ENV }"/>
        <li class="form-line" data-type="control_button" id="id_2">
          <div id="cid_2" class="form-input-wide">
            <div style="text-align: left; margin-top: 32px; margin-bottom: 60px" data-align="center" class="
                form-buttons-wrapper form-buttons-center
                jsTest-button-wrapperField
              ">
              <p class="footnote">
                Fields marked with an asterisk are required. </p>
              <button id="input_2" type="submit" class="
                  form-submit-button form-submit-button-none
                  submit-button
                  jf-form-buttons
                  jsTest-submitField
                " data-component="button" data-content="">
                SEND MY MESSAGE <i class="fas fa-caret-right"></i>
              </button>
            </div>
          </div>
        </li>
      </form>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      jotformAction: '',
    }
  },
  created () {
    var all_spc1 = document.querySelectorAll(
      'form[id=\'212315091962149\'] .si' + 'mple' + '_spc1',
    )
    for (var i = 0; i < all_spc1.length; i++) {
      all_spc1[i].value = '212315091962149-212315091962149'
    }
  },
  methods: {
    sendFormData () {
      const _this = this
      _this.axios.post(_this.$apiUrl + 'v1/email/save', {
        origin: 'beasunhero.com',
        from_name: document.getElementsByName('q8_name')[0].value,
        from_email: document.getElementsByName('q7_emailAddress')[0].value,
        message: document.getElementsByName('q4_yourMessage')[0].value,
      }).then(function (response) {
        if (response.data.errors.length === 0) {
          _this.$gtm.trackEvent({
            event: 'formAction',
            category: 'Form',
            action: 'Success',
            label: 'Submit Contact Us',
            value: 0,
          })
        }
        document.forms.form_212315091962149.setAttribute('action',
          'https://submit.jotform.com/submit/212315091962149/')
        document.forms.form_212315091962149.submit()
      }).catch(function () {
        _this.showLoader = false
        _this.$gtm.trackEvent({
          event: 'formAction',
          category: 'Form',
          action: 'Validation Error',
          label: 'Contact Us Form',
          value: 0,
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: hidden;
  // height: 50rem;
}

.container {
  // padding-left: 0;
  display: flex;
  flex-flow: column;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.superhero-image {
  width: 28rem;
  position: absolute;
  left: 32rem;
  top: 1rem;

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: none;
    width: 19rem;
    left: 26rem;
    top: 11rem;
  }
  @media screen and (max-width: ~"@{mq-sm-bp}em") {
    width: 13rem;
    left: 22rem;
  }
}

.contact-header {
  display: flex;
  padding-top: 65px;
  flex-flow: row wrap;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    justify-content: center;
    padding-top: 53px;
    margin-top: 0;
  }

  h1 {
    font-size: 60px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      font-size: 45px;
    }
  }

  .link-color {
    color: @color-dk-orange !important;
    text-decoration: underline;
    cursor: pointer;
  }

  p {
    margin-top: 8rem;
    @media screen and (max-width: ~"@{mq-sm-bp}em") {
      margin-top: 5rem;
    }
  }
}

.name-input {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  font-size: 14px;
  color: @color-txt-blue;
  @media screen and (max-width: 1000px) {
    width: 100%;
    // width: 31rem;
  }
}

.message-textarea {
  width: 723px;
  // max-height: 297px;
  font-size: 14px !important;
  color: @color-txt-blue;

  textarea {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 1000px) {
    max-width: 100%;
    // max-height: 297px;
    width: auto;
    height: auto;
  }
  resize: none;
}

.name-field {
  margin-right: 2.5rem;
}

form {
  p {
    margin-top: 0 !important;
  }

  button {
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;
  }
}

.form-row-1 {
  display: flex;
  padding-top: 4rem;
}

.form-row-2 {
  textarea {
    width: 72.3rem !important;
    height: 18rem !important;
  }
}

textarea {
  resize: none;
  font-size: 14px;
  color: @color-txt-blue;
  // height: 300px;
}

ul {
  li {
    list-style: none !important;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      width: 98%;
    }
  }
}

.jotform-form {
  margin-top: 20px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-left: -17px;
  }

  label {
    color: @color-txt-blue;
    font-size: 1.5rem;
    font-weight: 600;
    display: flex;
    flex-flow: row nowrap;

    span {
      color: #d80000;
    }
  }

  .form-buttons-wrapper {
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      margin-left: 2rem;
    }
  }

  ul {
    display: flex;
    flex-flow: row wrap;
    margin-left: 0;
    @media screen and (max-width: 1000px) {
      flex-direction: column;
    }

    @media screen and (max-width: ~"@{mq-md-bp}em") {
      margin-left: 2rem;
    }

    li {
      list-style: none;

      &#id_2 {
        margin-top: 20px;
      }

      &#id_7 {
        margin-top: -1px;
        margin-left: 30px;

        @media screen and (max-width: 1000px) {
          margin-left: 0px;
          // width: 100%;
        }
      }

      // &#input_7 {
      //   width: 34.6rem;
      //   height: 4.5rem;
      //   margin-top: 1rem;
      //   @media screen and (max-width: ~"@{mq-md-bp}em") {
      //     width: 100%;
      //     height: 4.5rem;
      //   }
      // }
      &::marker {
        list-style: none;
      }

      &#control_button {
        list-style: none;
      }
    }
  }

  .footnote {
    font-size: 11px;
    color: #000;
    margin-bottom: 10px;
  }
}
</style>
